import key from 'weak-key';

// types
import type { AwardBlockProps } from './awards.types';

// components
import { ExternalLink } from 'components/Link/ExternalLink';
import { Image } from 'components/image/image';

// utils
import { isEmpty } from 'utils/is-empty';

export function AwardBlock({ awards = [] }: Readonly<AwardBlockProps>) {
  if (isEmpty(awards)) return null;

  const images = awards.map((item, index) => {
    const img = (
      <div data-preview-id={`#${index}`}>
        <Image
          key={key(item)}
          data={item.pictureObject || item.picture}
          alt={item.pictureAlt}
          title={(item.description || item.pictureAlt) ?? ''}
        />
      </div>
    );

    return item.link ? (
      <ExternalLink content={item.link} key={key(item.link)}>
        {img}
      </ExternalLink>
    ) : (
      img
    );
  });

  return <div className="c-award__items">{images}</div>;
}
